import { render, staticRenderFns } from "./_apiData.vue?vue&type=template&id=94ccb1fe&scoped=true&"
import script from "./_apiData.vue?vue&type=script&lang=js&"
export * from "./_apiData.vue?vue&type=script&lang=js&"
import style0 from "./_apiData.vue?vue&type=style&index=0&id=94ccb1fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94ccb1fe",
  null
  
)

export default component.exports